import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchMe, loginAdmin } from '../api';

const AuthContext = createContext(null);

const TOKEN_KEY = 'aatreya_admin_token';

export const AuthProvider = ({ children }) => {
  // status: 'checking' | 'authed' | 'guest'
  const [status, setStatus] = useState('checking');
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setStatus('guest');
      return;
    }
    fetchMe()
      .then((data) => {
        setAdmin(data);
        setStatus('authed');
      })
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        setAdmin(null);
        setStatus('guest');
      });
  }, []);

  const login = async (email, password) => {
    const data = await loginAdmin(email, password);
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setAdmin({ email: data.email, role: 'admin' });
    setStatus('authed');
    return data;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setAdmin(null);
    setStatus('guest');
  };

  return (
    <AuthContext.Provider value={{ status, admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
